var _rect, _rect2, _line, _line2, _ellipse, _ellipse2, _tspan, _tspan2, _rect3, _rect4, _g, _g2, _g3, _g4, _tspan3, _tspan4, _line3, _line4, _line5, _line6, _line7, _line8, _tspan5, _rect5, _rect6, _g5, _rect7, _rect8, _tspan6, _tspan7, _tspan8, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _line9, _line0, _line1, _circle3, _circle4, _line10, _circle5, _circle6, _circle7, _circle8, _path7, _tspan9, _tspan0, _tspan1, _tspan10, _circle9, _circle0, _circle1, _circle10, _line11, _line12, _line13, _line14, _path8, _path9, _path0, _path1, _path10, _circle11, _circle12, _circle13, _circle14, _tspan11, _tspan12, _tspan13, _tspan14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _path11, _tspan15, _tspan16, _tspan17, _tspan18, _circle21, _circle22, _circle23, _circle24, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _circle25, _circle26, _circle27, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _path12, _tspan30, _rect9, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _tspan31, _circle39, _g6, _tspan32, _g7, _tspan33, _circle40, _circle41, _g8, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _tspan47, _tspan48, _g9, _line15, _g0, _line16, _tspan49, _tspan50, _tspan51, _tspan52, _path13, _path14, _line17, _line18, _tspan53, _line19, _line20, _line21, _line22, _line23, _line24, _path15, _path16, _path17, _path18, _path19, _path20, _line25, _line26, _tspan54, _tspan55, _rect0, _tspan56, _tspan57, _path21, _path22, _path23, _path24, _tspan58, _tspan59, _tspan60, _tspan61, _tspan62, _tspan63, _g1, _g10, _tspan64, _tspan65, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmCircuitDiagramSingleEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1547,
    height: 918,
    viewBox: "0 0 1547 918",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1547,
    height: 918,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Parralel Point",
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1547,
    height: 918,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RELAY ROOM"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "b24",
    x1: 51,
    y1: 168.5,
    x2: 162,
    y2: 168.5,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "n24",
    y1: -0.5,
    x2: 111.132,
    y2: -0.5,
    transform: "matrix(0.999838 -0.0179955 0.0170983 0.999854 50.0229 287.52)",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1",
    cx: 41.5,
    cy: 168.5,
    rx: 9.5,
    ry: 8.5,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 41.5,
    cy: 286,
    rx: 9.5,
    ry: 10,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 62,
    y: 180.864
  }, "B110"))), /*#__PURE__*/React.createElement("text", {
    id: "N110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 58,
    y: 299.864
  }, "N110"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 1.5,
    y: 1.5,
    width: 812,
    height: 389,
    stroke: "black",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    x: 846.5,
    y: 1.5,
    width: 699,
    height: 915,
    stroke: "black",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 153H199V297H164V153Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164 153H199V297H164V153Z",
    fill: "white",
    fillOpacity: 0.79,
    stroke: "black",
    strokeWidth: 4,
    mask: "url(#path-9-inside-1_0_1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-2_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301 153H341V296H301V153Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301 153H341V296H301V153Z",
    fill: "#FEFBFB",
    fillOpacity: 0.79,
    stroke: "black",
    strokeWidth: 4,
    mask: "url(#path-10-inside-2_0_1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-3_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301 153H341V296H301V153Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301 153H341V296H301V153Z",
    fill: "white",
    fillOpacity: 0.79,
    stroke: "black",
    strokeWidth: 4,
    mask: "url(#path-11-inside-3_0_1)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-4_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446 153H487V296H446V153Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446 153H487V296H446V153Z",
    fill: "white",
    fillOpacity: 0.79,
    stroke: "black",
    strokeWidth: 4,
    mask: "url(#path-12-inside-4_0_1)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "WRPR/WNPR",
    transform: "matrix(0 -1 1 0 310 289)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14.4545
  }, "WRPR/WNPR"))), /*#__PURE__*/React.createElement("text", {
    id: "NWR/RWR",
    transform: "matrix(0 -1 1 0 173 264)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14.4545
  }, "NWR/RWR"))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    x1: 197,
    y1: 168.5,
    x2: 301,
    y2: 168.5,
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line 2",
    x1: 197,
    y1: 284.5,
    x2: 301,
    y2: 284.5,
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line 4",
    x1: 342,
    y1: 168.5,
    x2: 446,
    y2: 168.5,
    stroke: "black"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line 6",
    x1: 487,
    y1: 284.5,
    x2: 590,
    y2: 284.5,
    stroke: "black"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 487,
    y1: 168.5,
    x2: 590,
    y2: 168.5,
    stroke: "black"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line 3",
    x1: 341,
    y1: 284.5,
    x2: 446,
    y2: 284.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "WCR",
    transform: "matrix(0 -1 1 0 454 251)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14.4545
  }, "WCR"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "RR",
    x: 914.5,
    y: 221.5,
    width: 181,
    height: 564,
    fill: "white",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "RR_2",
    x: 1127.5,
    y: 223.5,
    width: 77,
    height: 564,
    fill: "white",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "LB"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-5_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1223 223H1350V788H1223V223Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1223 223H1350V788H1223V223Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2",
    mask: "url(#path-24-inside-5_0_1)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "LB_2",
    x: 1373.5,
    y: 223.5,
    width: 127,
    height: 564,
    fill: "white",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "PM_A",
    x: 1410,
    y: 262,
    width: 54,
    height: 206,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_NW_LABEL",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 1422,
    y: 285.864
  }, "NW"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_RW_LABEL",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 1422,
    y: 384.864
  }, "RW"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_CW_LABEL",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 1422,
    y: 440.864
  }, "CW"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_ACW_LB2PM_",
    d: "M1298 437L1410 437",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_RW_LB2PM",
    d: "M1298 381L1410 381",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM",
    d: "M1298 283L1410 283",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM_2",
    d: "M1171 283L1278 283",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM_3",
    d: "M1171 437L1278 437",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM_4",
    d: "M1171 381L1278 381",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_NW_OUT",
    cx: 1299,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_NW_IN",
    cx: 1281,
    cy: 283,
    r: 3,
    fill: "black"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "LB_PM_A_NW_CONNECTOR",
    x1: 1282,
    y1: 283.5,
    x2: 1298,
    y2: 283.5,
    stroke: "black"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    id: "LB_PM_A_RW_CONNECTOR",
    x1: 1282,
    y1: 381.5,
    x2: 1298,
    y2: 381.5,
    stroke: "black"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    id: "LB_PM_A_CW_CONNECTOR",
    x1: 1282,
    y1: 437.5,
    x2: 1298,
    y2: 438.5,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_OUT",
    cx: 1173,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_IN",
    cx: 1154,
    cy: 283,
    r: 3,
    fill: "black"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "WIRE_PM_A_RR_IN",
    x1: 902,
    y1: 283.5,
    x2: 908,
    y2: 289.5,
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C1",
    cx: 1034,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C2",
    cx: 1034,
    cy: 306,
    r: 3,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C3",
    cx: 1075,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C4",
    cx: 1075,
    cy: 306,
    r: 3,
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "NWR_PM_A_NW",
    d: "M1046.58 283H1033.08L1027 287.583V305H1033.08L1046.58 283ZM1046.58 283H1059.42M1059.42 283H1072.92L1079 287.583V305H1072.92L1059.42 283Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 274.955
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "C2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 313.955
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "C3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 271.955
  }, "C3"))), /*#__PURE__*/React.createElement("text", {
    id: "C4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 313.955
  }, "C4"))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_OUT_2",
    cx: 1171,
    cy: 381,
    r: 3,
    fill: "black"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_OUT_3",
    cx: 1171,
    cy: 437,
    r: 3,
    fill: "black"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_OUT_4",
    cx: 1153,
    cy: 437,
    r: 3,
    fill: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_IN_2",
    cx: 1153,
    cy: 381,
    r: 3,
    fill: "black"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "CTR_PM_A_RW_CONNECTOR",
    x1: 1152,
    y1: 381.5,
    x2: 1169,
    y2: 381.5,
    stroke: "black"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "CTR_PM_A_NW_CONNECTOR",
    x1: 1153,
    y1: 283.5,
    x2: 1170,
    y2: 283.5,
    stroke: "black"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "CTR_PM_A_CW_CONNECTOR",
    x1: 1152,
    y1: 437.5,
    x2: 1169,
    y2: 437.5,
    stroke: "black"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "NO ID",
    x1: 988,
    y1: 283.5,
    x2: 1033,
    y2: 283.5,
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_CW_RR2CTR",
    d: "M904 437H1150",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_RR2CTR",
    d: "M1073 283H1152",
    stroke: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_RW_RR2CTR",
    d: "M1073 381H1151",
    stroke: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "NO ID_2",
    d: "M1033.16 305.481L1017.33 314.998L1017.33 382.332L1033.16 382.332",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "RWR_PM_A_RW",
    d: "M1046.58 381H1033.08L1027 386V405H1033.08L1046.58 381ZM1046.58 381H1059.42M1059.42 381H1072.92L1079 386V405H1072.92L1059.42 381Z",
    stroke: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C1_2",
    cx: 1034,
    cy: 382,
    r: 3,
    fill: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C2_2",
    cx: 1034,
    cy: 404,
    r: 3,
    fill: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C3_2",
    cx: 1075,
    cy: 382,
    r: 3,
    fill: "black"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C4_2",
    cx: 1075,
    cy: 404,
    r: 3,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 372.955
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "C2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 413.955
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "C3_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 370.955
  }, "C3"))), /*#__PURE__*/React.createElement("text", {
    id: "C4_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 413.955
  }, "C4"))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C1_3",
    cx: 948,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "B110V_BB_PM",
    cx: 902,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "N110V_BB_PM",
    cx: 902,
    cy: 437,
    r: 3,
    fill: "black"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C2_3",
    cx: 948,
    cy: 306,
    r: 3,
    fill: "black"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C3_3",
    cx: 990,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C4_3",
    cx: 990,
    cy: 306,
    r: 3,
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "WCR_PM_A",
    d: "M961.584 283H948.078L942 287.583V305H948.078L961.584 283ZM961.584 283H974.416M974.416 283H987.922L994 287.583V305H987.922L974.416 283Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C1_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 944,
    y: 274.955
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "C2_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 944,
    y: 313.955
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "C3_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 986,
    y: 271.955
  }, "C3"))), /*#__PURE__*/React.createElement("text", {
    id: "C4_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 986,
    y: 313.955
  }, "C4"))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_RW_OUT",
    cx: 1299,
    cy: 381,
    r: 3,
    fill: "black"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_RW_IN",
    cx: 1281,
    cy: 381,
    r: 3,
    fill: "black"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_CW_OUT",
    cx: 1299,
    cy: 437,
    r: 3,
    fill: "black"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_CW_IN",
    cx: 1281,
    cy: 437,
    r: 3,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B110_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 863,
    y: 295.864
  }, "B110"))), /*#__PURE__*/React.createElement("text", {
    id: "N110_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 863,
    y: 449.864
  }, "N110"))), /*#__PURE__*/React.createElement("text", {
    id: "LOCATION BOX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 1231,
    y: 208.636
  }, "LOCATION BOX"))), /*#__PURE__*/React.createElement("text", {
    id: "Machine Location",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 1390,
    y: 208.636
  }, "Machine Location"))), /*#__PURE__*/React.createElement("text", {
    id: "CT RACK",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 1135,
    y: 208.636
  }, "CT RACK"))), /*#__PURE__*/React.createElement("text", {
    id: "RELAY ROOM_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 963,
    y: 208.636
  }, "RELAY ROOM"))), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 100",
    cx: 1416,
    cy: 281,
    r: 6,
    fill: "black"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 101",
    cx: 1416,
    cy: 381,
    r: 6,
    fill: "black"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 102",
    cx: 1416,
    cy: 436,
    r: 6,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Point Machine end motor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 1403,
    y: 231.909
  }, "Point Machine")), _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 1403,
    y: 241.909
  }, "motor"))), /*#__PURE__*/React.createElement("text", {
    id: "NW_PointA",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 1233,
    y: 374.5
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "RW_PointA",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 1233,
    y: 273.5
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "CW_PointA",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 1233,
    y: 429.5
  }, "..........")))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M633.5 233C633.5 255.049 630.259 274.989 625.036 289.398C622.424 296.605 619.325 302.402 615.908 306.388C612.491 310.375 608.803 312.5 605 312.5C601.197 312.5 597.509 310.375 594.092 306.388C590.675 302.402 587.576 296.605 584.964 289.398C579.741 274.989 576.5 255.049 576.5 233C576.5 210.951 579.741 191.011 584.964 176.602C587.576 169.395 590.675 163.598 594.092 159.612C597.509 155.625 601.197 153.5 605 153.5C608.803 153.5 612.491 155.625 615.908 159.612C619.325 163.598 622.424 169.395 625.036 176.602C630.259 191.011 633.5 210.951 633.5 233Z",
    fill: "white",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "110V DC",
    transform: "matrix(0 -1 1 0 596 258)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14.4545
  }, "110V DC"))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 1.5,
    y: 422.5,
    width: 812,
    height: 492,
    stroke: "black",
    strokeWidth: 3
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 62.5,
    cy: 518.5,
    r: 7,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 31",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 134 511)",
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 164 510)",
    stroke: "black"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 166 719)",
    stroke: "black"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 166 827)",
    stroke: "black"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 226 828)",
    stroke: "black"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 164 629)",
    stroke: "black"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 223 510)",
    stroke: "black"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 453 510)",
    stroke: "black"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 60",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 512 510)",
    stroke: "black"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 225 719)",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "LOCATION BOX_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 430,
    y: 474.864
  }, "LOCATION  BOX"))), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 35",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 223 629)",
    stroke: "black"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "RWKR_INDOOR"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-118-inside-6_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 517H115V534H74V517Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74 517H115V534H74V517Z",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-118-inside-6_0_1)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "RWKR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 75,
    y: 528.864
  }, "RWKR"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "RWKR_OUTDOOR"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-120-inside-7_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455 517H496V534H455V517Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455 517H496V534H455V517Z",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-120-inside-7_0_1)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "RWKR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 456,
    y: 528.864
  }, "RWKR"))), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 61",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 453 720)",
    stroke: "black"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 62",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 512 720)",
    stroke: "black"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "NWKR_OUTDOOR"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-124-inside-8_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455 727H496V744H455V727Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455 727H496V744H455V727Z",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-124-inside-8_0_1)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "NWKR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 456,
    y: 738.864
  }, "NWKR"))), /*#__PURE__*/React.createElement("text", {
    id: "NWKR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 79,
    y: 738.864
  }, "NWKR"))), /*#__PURE__*/React.createElement("text", {
    id: "R1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 111,
    y: 545.864
  }, "R1"))), /*#__PURE__*/React.createElement("text", {
    id: "R1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 121,
    y: 760.864
  }, "R1"))), /*#__PURE__*/React.createElement("text", {
    id: "R2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 65,
    y: 545.864
  }, "R2"))), /*#__PURE__*/React.createElement("text", {
    id: "R2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 66,
    y: 760.864
  }, "R2"))), /*#__PURE__*/React.createElement("text", {
    id: "RWR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 172,
    y: 513.864
  }, "RWR"))), /*#__PURE__*/React.createElement("text", {
    id: "A7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 208,
    y: 505.864
  }, "A7"))), /*#__PURE__*/React.createElement("text", {
    id: "A7_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 210,
    y: 709.864
  }, "A7"))), /*#__PURE__*/React.createElement("text", {
    id: "A7_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 145,
    y: 819.864
  }, "A7"))), /*#__PURE__*/React.createElement("text", {
    id: "A7_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 145,
    y: 625.864
  }, "A7"))), /*#__PURE__*/React.createElement("text", {
    id: "A8",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 148,
    y: 505.864
  }, "A8"))), /*#__PURE__*/React.createElement("text", {
    id: "A8_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 625.864
  }, "A8"))), /*#__PURE__*/React.createElement("text", {
    id: "A8_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 151,
    y: 709.864
  }, "A8"))), /*#__PURE__*/React.createElement("text", {
    id: "A8_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 207,
    y: 819.864
  }, "A8"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 34_2",
    d: "M296.134 516.89C296.134 523.037 300.946 527.991 306.846 527.991C312.746 527.991 317.558 523.037 317.558 516.89C317.558 510.742 312.746 505.788 306.846 505.788C300.946 505.788 296.134 510.742 296.134 516.89Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 35_2",
    d: "M389.035 516.89C389.035 523.037 393.847 527.991 399.747 527.991C405.647 527.991 410.459 523.037 410.459 516.89C410.459 510.742 405.647 505.788 399.747 505.788C393.847 505.788 389.035 510.742 389.035 516.89Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 59",
    x1: 307.38,
    y1: 505.893,
    x2: 400.281,
    y2: 505.893,
    stroke: "black"
  }))), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "Line 60",
    x1: 306,
    y1: 527.5,
    x2: 399,
    y2: 527.5,
    stroke: "black"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 34_3",
    d: "M290.795 636.22C290.795 642.367 295.607 647.321 301.507 647.321C307.407 647.321 312.219 642.367 312.219 636.22C312.219 630.072 307.407 625.118 301.507 625.118C295.607 625.118 290.795 630.072 290.795 636.22Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 35_3",
    d: "M383.696 636.22C383.696 642.367 388.508 647.321 394.408 647.321C400.308 647.321 405.12 642.367 405.12 636.22C405.12 630.072 400.308 625.118 394.408 625.118C388.508 625.118 383.696 630.072 383.696 636.22Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 59_2",
    x1: 302.041,
    y1: 625.223,
    x2: 394.942,
    y2: 625.223,
    stroke: "black"
  })))), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "Line 63",
    x1: 302,
    y1: 647.5,
    x2: 395,
    y2: 647.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B24",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 715,
    y: 501.864
  }, "B24"))), /*#__PURE__*/React.createElement("text", {
    id: "B24_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 715,
    y: 711.864
  }, "B24"))), /*#__PURE__*/React.createElement("text", {
    id: "N24",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 715,
    y: 619.864
  }, "N24"))), /*#__PURE__*/React.createElement("text", {
    id: "N24_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 715,
    y: 818.864
  }, "N24"))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "B24_PointA_RWKR_WIRE_STATUS",
    d: "M50.0408 516.942L741.001 518.047",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "B24_PointB_RWKR_WIRE_STATUS",
    d: "M50.0408 726.942L741.5 726.942",
    stroke: "black"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "N24_RWKR_WIRE_STATUS",
    x1: 50,
    y1: 636.5,
    x2: 741,
    y2: 636.5,
    stroke: "black"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    id: "B24N24_RWKR_LINE",
    x1: 49.5,
    y1: 637,
    x2: 49.5,
    y2: 516,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "WRKR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 167,
    y: 631.864
  }, "WRKR"))), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    id: "Line 69",
    y1: -0.5,
    x2: 48.6269,
    y2: -0.5,
    transform: "matrix(0.0219591 0.999759 -0.999724 0.0235101 352.229 494.239)",
    stroke: "black"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    id: "Line 71",
    opacity: 0.9,
    x1: 351.5,
    y1: 666,
    x2: 351.5,
    y2: 617,
    stroke: "black"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    id: "B24N24_NWKR_LINE",
    x1: 50.5,
    y1: 727,
    x2: 50.5,
    y2: 836,
    stroke: "black"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    id: "N24_RWKR_WIRE_STATUS_2",
    x1: 50,
    y1: 835.5,
    x2: 741,
    y2: 835.5,
    stroke: "black"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    id: "Line 76",
    x1: 322.5,
    y1: 556,
    x2: 322.5,
    y2: 604,
    stroke: "black"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    id: "Line 78",
    x1: 318.5,
    y1: 762,
    x2: 318.5,
    y2: 809,
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 36",
    d: "M315.5 835C315.5 841.922 310.109 847.5 303.5 847.5C296.891 847.5 291.5 841.922 291.5 835C291.5 828.078 296.891 822.5 303.5 822.5C310.109 822.5 315.5 828.078 315.5 835Z",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 45",
    d: "M350.5 785.5C350.5 792.189 345.741 797.5 340 797.5C334.259 797.5 329.5 792.189 329.5 785.5C329.5 778.811 334.259 773.5 340 773.5C345.741 773.5 350.5 778.811 350.5 785.5Z",
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 53",
    d: "M350.5 578.5C350.5 585.189 345.741 590.5 340 590.5C334.259 590.5 329.5 585.189 329.5 578.5C329.5 571.811 334.259 566.5 340 566.5C345.741 566.5 350.5 571.811 350.5 578.5Z",
    stroke: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 37",
    d: "M314.5 728C314.5 734.922 309.109 740.5 302.5 740.5C295.891 740.5 290.5 734.922 290.5 728C290.5 721.078 295.891 715.5 302.5 715.5C309.109 715.5 314.5 721.078 314.5 728Z",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 38",
    d: "M405.5 727C405.5 733.963 400.519 739.5 394.5 739.5C388.481 739.5 383.5 733.963 383.5 727C383.5 720.037 388.481 714.5 394.5 714.5C400.519 714.5 405.5 720.037 405.5 727Z",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 39",
    d: "M407.5 835C407.5 841.922 402.109 847.5 395.5 847.5C388.891 847.5 383.5 841.922 383.5 835C383.5 828.078 388.891 822.5 395.5 822.5C402.109 822.5 407.5 828.078 407.5 835Z",
    stroke: "black"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    id: "Line 80",
    x1: 348.5,
    y1: 709,
    x2: 348.5,
    y2: 745,
    stroke: "black"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    id: "Line 83",
    x1: 351.5,
    y1: 817,
    x2: 351.5,
    y2: 853,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "NWR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 175,
    y: 723.864
  }, "NWR"))), /*#__PURE__*/React.createElement("text", {
    id: "WNKR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan55 || (_tspan55 = /*#__PURE__*/React.createElement("tspan", {
    x: 167,
    y: 829.864
  }, "WNKR"))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "NWKR_INDOOR",
    x: 72.5,
    y: 727.5,
    width: 49,
    height: 20,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan56 || (_tspan56 = /*#__PURE__*/React.createElement("tspan", {
    x: 395,
    y: 501.864
  }, "B1"))), /*#__PURE__*/React.createElement("text", {
    id: "B2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan57 || (_tspan57 = /*#__PURE__*/React.createElement("tspan", {
    x: 387,
    y: 663.864
  }, "B2"))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M293 823C293 815.842 295.378 810.113 300.003 804.653C303.461 800.571 309.729 795.312 315 794",
    stroke: "black",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M291 743C291 759.182 298.333 776.524 314 780",
    stroke: "black",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M299 532C299 548.182 306.333 565.524 322 569",
    stroke: "black",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M294.037 626.026C294.021 609.844 302.175 592.494 319.63 589",
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan58 || (_tspan58 = /*#__PURE__*/React.createElement("tspan", {
    x: 386,
    y: 706.864
  }, "B3"))), /*#__PURE__*/React.createElement("text", {
    id: "B4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan59 || (_tspan59 = /*#__PURE__*/React.createElement("tspan", {
    x: 386,
    y: 858.864
  }, "B4"))), /*#__PURE__*/React.createElement("text", {
    id: "B5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan60 || (_tspan60 = /*#__PURE__*/React.createElement("tspan", {
    x: 299,
    y: 502.864
  }, "B5"))), /*#__PURE__*/React.createElement("text", {
    id: "B6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan61 || (_tspan61 = /*#__PURE__*/React.createElement("tspan", {
    x: 293,
    y: 663.864
  }, "B6"))), /*#__PURE__*/React.createElement("text", {
    id: "B7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan62 || (_tspan62 = /*#__PURE__*/React.createElement("tspan", {
    x: 292,
    y: 707.864
  }, "B7"))), /*#__PURE__*/React.createElement("text", {
    id: "B8",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan63 || (_tspan63 = /*#__PURE__*/React.createElement("tspan", {
    x: 289,
    y: 859.864
  }, "B8"))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_2",
    cx: 320.219,
    cy: 568.292,
    r: 2.5,
    fill: "#141313"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54",
    cx: 320.219,
    cy: 589.551,
    r: 2.5,
    fill: "#141313"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_3",
    cx: 316.287,
    cy: 779.596,
    r: 2.5,
    fill: "#141313"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_2",
    cx: 316.5,
    cy: 793.5,
    r: 2.5,
    fill: "#141313"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "POINT MACHINE",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan64 || (_tspan64 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 475.864
  }, "POINT MACHINE"))), /*#__PURE__*/React.createElement("text", {
    id: "RELAY ROOM AT STATION",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan65 || (_tspan65 = /*#__PURE__*/React.createElement("tspan", {
    x: 50,
    y: 474.864
  }, "RELAY ROOM AT STATION"))), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 339,
    cy: 579,
    r: 3,
    fill: "#111010"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 339,
    cy: 786,
    r: 3,
    fill: "#111010"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 63",
    cx: 743,
    cy: 519,
    r: 3,
    fill: "#111010"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 64",
    cx: 743,
    cy: 637,
    r: 3,
    fill: "#111010"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65",
    cx: 743,
    cy: 727,
    r: 3,
    fill: "#111010"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 66",
    cx: 743,
    cy: 835,
    r: 3,
    fill: "#111010"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52",
    cx: 62.5,
    cy: 728.5,
    r: 7,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 141 720)",
    fill: "#D9D9D9",
    fillOpacity: 0.99,
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1547,
    height: 918,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmCircuitDiagramSingleEnd);
export default __webpack_public_path__ + "static/media/pm_circuit_diagram_single_end.2e17418dd9d9ac77e79cbfef260e1673.svg";
export { ForwardRef as ReactComponent };